// extracted by mini-css-extract-plugin
export var title = "styles-module--title--3e4bd";
export var wrapper = "styles-module--wrapper--43a5f";